module.exports = __webpack_public_path__ + "static/media/bread-brunch-table.f5efc722.jpg";